import Service from "../Service";

const resource = "MRLs/";

export default {

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        console.log(obj)
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    list(CmaID, requestID) {
        return Service.post(resource + "list", null, {
            params: { CmaID: CmaID, requestID: requestID },
        });
    },
    MatrizMRLs(parameters, requestID) {
        return Service.post(resource + "MatrizMRLs", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    ResultadoMatriz(parameters, requestID) {
        return Service.post(resource + "ResultadoMatriz", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
};